module.exports = __webpack_public_path__ + "static/img/EP202504081424414.804e8c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/detail/EP202504081424414.jpg
// module id = CKdg
// module chunks = 1